<template>
  <v-container id="uploadFile">
    <v-card max-width="800px">
      <v-card-title class="headerTitle">
{{ $t('upload-presentation-slides') }}
</v-card-title>
      <v-overlay :value="uploadProgress">
                  <v-progress-circular
                    indeterminate
                    size="64"
                  />
            </v-overlay>
        <v-card-text if="!validated">
              <h3 class="text-center text-white pt-10">
{{ $t('as-a-user-you-can-upload-presentation-slides-in-pdf-form-that-are-less-than-10mbs') }}
</h3>
              <h3 class="text-center pt-10 red--text">
{{ uploadFileError }}
</h3>
              <v-card-actions>
              <input ref="userFile" type="file" class="pt-14 mx-auto" name="uploadedFile" @change="selectFile">
              </v-card-actions>
        </v-card-text>
      <v-card-actions>
        <br>
        <v-spacer />
          <h3 v-if="exceededMaxFileUploaded" class="text-center pt-10 red--text">
{{ $t('you-have-exceeded-the-maximum-number-of-files-10-that-can-be-uploaded') }}
</h3>
        <v-card-actions class="pr-14">
          <v-btn color="red" @click="cancelUpload">
{{ $t('global.cancel') }}
</v-btn>
          <v-btn color="blue" :disabled="!validated" class="mx-auto" @click="uploadFile">
{{ $t('upload-file') }}
</v-btn>
        </v-card-actions>
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
  import api from '@/helpers/api.js'
  export default {
    name: '',
    props: {
      exceededMaxFileUploaded: { type: Boolean, required: false, default: false },
    },
    data () {
      return {
        file: null,
        uploadProgress: false,
        documentID: null,
        uploadFileError: '',
        uploadInstructions: '',
        exceededMaxFileUploadedMessage: '',
      }
    },
    computed: {
      validated () {
        if (this.file) {
          if (this.file.type !== 'application/pdf' || this.file.size > 10000000 || this.exceededMaxFileUploaded) {
            return false
          } else {
            return true
          }
        } else {
          return false
        }
      },
    },
    methods: {
      async loadFile (file) {
        const reader = new FileReader()
        reader.readAsText(file, 'UTF-8')

        reader.onload = async (evt) => {
          if (file.type !== 'application/pdf') {
            this.file = null
            this.uploadFileError = this.$t('you-can-only-upload-pdf-files')
            console.error('Invalid file type')
          }
          if (file.size > 10000000) {
            this.file = null
            this.uploadFileError = this.$t('file-size-should-be-less-than-10mbs')
            console.error('File size is greater than 10mbs')
          }
          if (this.file) {
            this.uploadProgress = true
            this.documentID = await api.getDocument(this.file.name)
            if (this.documentID) {
              this.uploadFileError = 'File already exists,would like to replace it?'
            }
            this.uploadProgress = false
          }
        }
        reader.onerror = evt => {
          console.error('file read error = ' + reader.error)
        }
      },
      cancelUpload () {
        this.file = null
        this.uploadFileError = ''
        this.$emit('closeModal')
      },
      selectFile () {
        this.file = this.$refs.userFile.files[0]
        this.uploadFileError = ''
        this.loadFile(this.file)
      },
      async uploadFile () {
        const formData = new FormData()
        formData.append('uploadedFile', this.file, this.file.name)
        this.$emit('uploadedFileToSave', formData)
        this.$emit('save')
        this.file = null
        this.uploadFileError = ''
        this.$refs.userFile.value = null
      },
      setUploadError (errorMessage) {
        this.uploadFileError = errorMessage
      },
    },

  }
</script>


<style scoped>
  .status {
    padding: 5px 10px;
    border-radius: 5px;
    width: 150px;
    text-align: center;
  }
  .headerTitle {
       padding: 24px 24px 27px !important
  }
  .inviteSent { background-color: grey; color: white; }
  .awaitingSubmission { background-color: orange; color: white; }
  .submitted { background-color: red; color: white; }
  .reviewed { background-color: green; color: white; }
</style>
